<div class="inputContainer">
  <input *ngFor="let item of this.inputValues; let i = index"
         class="ui input"
         type="{{password? 'password' : 'text'}}"
         [(ngModel)]="inputValues[i]"
         (focus)="onFocusInput(i)"/>
</div>

<div class="keyboardMain">
  <div class="numArea">

    <div class="numericItem" (click)="onNumPress(1)"><span>1</span></div>
    <div class="numericItem" (click)="onNumPress(2)"><span>2</span></div>
    <div class="numericItem" (click)="onNumPress(3)"><span>3</span></div>
    <div class="numericItem" (click)="onNumPress(4)"><span>4</span></div>
    <div class="numericItem" (click)="onNumPress(5)"><span>5</span></div>
    <div class="numericItem" (click)="onNumPress(6)"><span>6</span></div>
    <div class="numericItem" (click)="onNumPress(7)"><span>7</span></div>
    <div class="numericItem" (click)="onNumPress(8)"><span>8</span></div>
    <div class="numericItem" (click)="onNumPress(9)"><span>9</span></div>
    <div class="numericItem" (click)="onNumPress(0)"><span>0</span></div>
    <div class="numericItem" (click)="onNumPress('input_back')"><img style="transform: rotate(180deg)"
                                                                     src="/Images/keyboard_icons/button_arrow.png">
    </div>
    <div class="numericItem" (click)="onNumPress('input_next')"><img src="/Images/keyboard_icons/button_arrow.png">
    </div>


  </div>
  <div class="funcArea">
    <div class="numericItem" (click)="onNumPress('backspace')"><img src="/Images/keyboard_icons/backspace.png"></div>
    <div class="numericItem" (click)="onNumPress('enter')"><img src="/Images/keyboard_icons/enter_key.png"></div>
  </div>

</div>
